export default __webpack_public_path__ + "static/media/importHover.ca8e16e0.svg";